import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/site";

export const Testimonials = () => {
  return (
    <section className="relative py-20 md:py-32 bg-garnet text-cream overflow-hidden">
      <div className="absolute inset-0 grain pointer-events-none opacity-30" />
      <div className="container-narrow relative">
        <div className="max-w-3xl">
          <span className="overline text-gold-soft">Words from our family</span>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl text-cream leading-[1.05]">
            Heirlooms come with <span className="italic text-gold">stories</span>.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="border-t border-cream/15 pt-8"
            >
              <Quote className="text-gold" size={28} strokeWidth={1} />
              <blockquote className="mt-6 font-serif text-2xl md:text-[1.6rem] leading-[1.4] text-cream">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8">
                <p className="text-cream font-medium">{t.name}</p>
                <p className="overline mt-1 text-gold-soft">{t.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
